import { center } from '@flipster/styled-system/patterns';

export const getTopRankItemStyle = (rank: number) =>
  rank === 1
    ? center({
        flexDir: 'column',
        p: 24,
        pb: 48,
        rounded: 16,
        gap: 24,
        w: { base: '100%', tablet: 680 },
        minH: { base: 297, tablet: 333 },
        bg: {
          base: 'linear-gradient(0deg, #111111, rgba(var(--key-color-rgb), 0.2) 60%)',
          tablet: 'linear-gradient(0deg, #111111, rgba(var(--key-color-rgb), 0.2) 50%)',
        },
      })
    : center({
        flexDir: 'column',
        p: 24,
        pb: 48,
        rounded: 16,
        gap: 24,
        w: { base: '100%', tablet: 680 },
        mt: { tablet: 44 },
        minH: { base: 286, tablet: 289 },
        bg: {
          base: 'linear-gradient(0deg, #111111, rgba(var(--key-color-rgb), 0.2) 80%)',
          tablet: 'linear-gradient(0deg, #111111, rgba(var(--key-color-rgb), 0.2) 70%)',
        },
      });
